import styled from "@emotion/styled";

const ContentContainer = styled.div`
    width: 90%;
    margin: 0 auto;
`;

export default ContentContainer;